import { render, staticRenderFns } from "./orders-additional-properties.vue?vue&type=template&id=548818e3&scoped=true"
import script from "./orders-additional-properties.vue?vue&type=script&lang=js"
export * from "./orders-additional-properties.vue?vue&type=script&lang=js"
import style0 from "./orders-additional-properties.vue?vue&type=style&index=0&id=548818e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548818e3",
  null
  
)

export default component.exports